<template lang="html">
  <div class="container">
    <div class="content">
      <div class="columns">
        <div class="column">
          <h3>Education</h3>
          <ul>
            <li>2012 UCSB | Philosophy{{ " & " }}Mathematics</li>
            <li>2005 The Thacher School</li>
          </ul>
        </div>
      </div>
      <div class="columns">
        <div class="column is-three-fifths">
          <h3>Values</h3>
          <ul>
            <li>Complexity is easy.</li>
            <li>Simplicity is hard.</li>
            <li><a href="https://123philosophy.wordpress.com/wp-content/uploads/2019/08/max-black-the-identity-of-indiscernibles-1.pdf">Identity is foundational to everything.</a></li>
            <li>DRY: Don't Repeat Yourself.</li>
            <li><a href="https://tom.preston-werner.com/2010/08/23/readme-driven-development.html">RDD: Readme Driven Development.</a></li>
            <li><a href="https://martinfowler.com/bliki/StranglerFigApplication.html">An API is a testable agreement</a> ...</li>
            <li><a href="https://www.hyrumslaw.com/">... although sometimes it's not.</a></li>
            <li>Leave it cleaner than when you arrived.</li>
            <li><a href="https://fs.blog/hunter-s-thompson-to-hume-logan/">Dear Hume</a><small> - Hunter S. Thompson</small></li>
          </ul>
          <h3 class="header">Experience</h3>
          <ul>
            <li><strong>Cloud & Bare-metal Infrastructure:</strong> Containers, VMs, Hybrid cloud, VPNs and firewalls.</li>
            <li><strong>Automation & CI/CD:</strong> Automation of a wide range of tasks, deploying to production machines at scale, and designing Docker-based CI/CD pipelines for telco, medical and industrial services.</li>
            <li><strong>Edge Device Architecture & Security:</strong> Designing encrypted connections, inventory management, and lifecycle management of edge devices, including machine-to-machine and user authentication mechanisms.</li>
            <li><strong>Identity & Credentialing:</strong> Architecture of APIs for provisioning ephemeral and RBAC scoped credentials ensuring time-limited and risk-adjusted authentication.</li>
            <li><strong>Device State & Monitoring:</strong> Developing systems for centralized metric collection and alerting on edge device health and connectivity status.</li>
            <li><strong>Manufacturing, Provisioning & Deployment:</strong> Implementing trust and provisioning mechanisms for edge devices at the end of manufacturing, allowing them to be securely brought into trust for immediate shipment.</li>
            <li><strong>Networking & Security:</strong> Network engineering, hardware validation via packet inspection, and mitigation of security breaches.</li>
            <li><strong>Customer & Product Strategy:</strong> Managing airgapped network customer relations, designing products to maximize reliability and minimize customer-side requirements.</li>
            <li><strong>Development & Systems:</strong> RESTful API development, front-end UX development, GitHub project management, Linux & Windows system administration.</li>
            <li><strong>Specialized Development:</strong> API design and implementation for FPGA based products.</li>
            <li><strong>Management & Sales Engineering:</strong> Leading interns successfully and engaging with clients like BBC, BT, NASA, and Vodafone.</li>
          </ul>
        </div>
        <div class="column is-two-fifths">
          <h3>Languages</h3>
          <ul>
            <li>Go</li>
            <li>Python</li>
            <li>NodeJS</li>
            <li>Ruby</li>
            <li>Javascript (Browser {{"&"}} Node)</li>
            <li>Typescript (Browser {{"&"}} Node)</li>
            <li>HTML, CSS</li>
            <li>HCL</li>
            <li>Dockerfile</li>
            <li>Bash</li>
            <li>Powershell</li>
            <li>Nix</li>
          </ul>
          <h3>Domains</h3>
          <ul>
            <li>Cloud Architecture</li>
            <li>Edge Architecture</li>
            <li>Tunneling / VPNs</li>
            <li>RESTful APIs</li>
            <li>API Gateways</li>
            <li>Single Page Applications</li>
            <li>Networking</li>
            <li>OAuth</li>
            <li>Linux / Windows</li>
          </ul>
          <h3>Tech I Like</h3>
          <ul>
            <li><a href="https://aws.amazon.com/developer/tools/">AWS SDKs</a>, <a href="https://www.terraform.io/">Terraform</a></li>
            <li><a href="https://aws.amazon.com/iam/">IAM</a>, <a href="https://auth0.com/">Auth0</a></li>
            <li><a href="https://www.wireguard.com/">Wireguard</a>, <a href="https://tailscale.com/">Tailscale</a>, <a href="https://pritunl.com/">Pritunl</a></li>
            <li><a href="https://www.opencontainers.org/">The OCI standard</a>, <a href="https://www.docker.com/">Docker</a>, <a href="https://aws.amazon.com/lambda/">Lambda</a>, <a href="https://aws.amazon.com/eks/">EKS</a></li>
            <li><a href="https://pydantic.dev/">Pydantic</a>, <a href="https://ai.pydantic.dev/">Pydantic AI</a></li>
            <li><a href="https://fastapi.tiangolo.com/">FastAPI</a>, <a href="https://goa.design/">Goa</a>, <a href="https://expressjs.com/">Express</a>, <a href="https://sinatrarb.com/">Sinatra</a></li>
            <li><a href="https://github.com/shellspec/shellspec">Shellspec</a>, <a href="https://docs.pytest.org/en/stable/">Pytest</a>, <a href="https://rspec.info/">Rspec</a></li>
            <li><a href="https://www.netboot.xyz">PXE</a>, <a href="https://www.isc.org/bind/">DNSMasq</a></li>
            <li><a href="https://github.com/">GitHub</a>, <a href="https://about.gitlab.com/">GitLab</a>, <a href="https://git-scm.com/">Git</a></li>
            <li><a href="https://github.com/features/actions">Github Actions</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'middle'
}
</script>

<style lang="css">
li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Middle.vue